import LoginContainer from "@containers/Auth/LoginContainer/LoginContainer.tsx";

const Login = () => <LoginContainer />;

export default Login;
